import React from 'react';

export const PrevArrow = ({ onClick, currentSlide, slideCount }) => <div style={{ display: currentSlide === 0 ? 'none' : 'block' }} onClick={onClick} className="slider-left" />;


export const NextArrow = ({ onClick, currentSlide, slideCount }) => <div style={{ display: currentSlide + 2 === slideCount ? 'none' : 'block' }} onClick={onClick} className="slider-right" />;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Geozones/SliderArrows.js